import { createSelector } from '@reduxjs/toolkit';
import { EWindowsType } from '../../../../packages/api-models/common/json_query';
import { selectWindowType } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Во двор', value: EWindowsType.Courtyard },
  { label: 'На улицу', value: EWindowsType.Street },
];

export const selectWindowsFilter = createSelector(selectWindowType, value => ({
  label: 'Вид из окна',
  value: [value],
  options: OPTIONS,
}));
